class SnakeBorderAnimation {
    static resizeTimeout = null;

    static init() {
        this.initSnakeBorder();
        window.addEventListener('load', () => this.initSnakeBorder());
        window.addEventListener('resize', () => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => this.initSnakeBorder(), 150);
        });
    }

    static initSnakeBorder() {
        document.querySelectorAll('.snake-svg').forEach((svg) => {
            const rect = svg.querySelector('.snake');

            rect.getAnimations().forEach(anim => anim.cancel());

            const box = svg.getBoundingClientRect();
            const w = box.width;
            const h = box.height;

            const rx = 3 * (w / 100);
            const ry = 3 * (h / 100);

            const perimeter =
                2 * (w + h - 2 * rx - 2 * ry) +
                2 * Math.PI * Math.min(rx, ry);

            const snakeLength = perimeter * 0.15;

            rect.style.strokeDasharray = `${snakeLength} ${perimeter}`;
            rect.style.strokeDashoffset = 0;

            rect.animate(
                [
                    { strokeDashoffset: 0 },
                    { strokeDashoffset: -(perimeter + snakeLength) }
                ],
                {
                    duration: 3000,
                    iterations: Infinity,
                    easing: 'linear'
                }
            );
        });
    }
}

export default SnakeBorderAnimation;
